import React, { useEffect } from 'react';
import { Modal, Form, Col, Row, Input } from 'antd';

function UserModal(props: any) {
	const { visible, onClose, onSave, saving, selectedOrg } = props;

	const [form] = Form.useForm();

	function saveForm(values: any) {
		values.organization_id = selectedOrg.id;
		onSave(values);
	}

	useEffect(() => {
		form.resetFields();
	}, [visible]);

	return (
		<Modal
			okText="Save"
			cancelText="Cancel"
			title={'Add user to organization'}
			okButtonProps={{ loading: saving }}
			visible={visible}
			onOk={() => form.submit()}
			destroyOnClose={true}
			onCancel={onClose}
		>
			<Form form={form} id="userForm" onFinish={saveForm} layout="vertical">
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item name="name" label="Name" rules={[{ required: true, message: 'Please user name' }]}>
							<Input placeholder="Name" />
						</Form.Item>
					</Col>
					<Col span={24}>
						<Form.Item
							name="email"
							label="Email"
							rules={[{ required: true, message: 'Please Enter email' }]}
						>
							<Input placeholder="Email" />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
}

export default UserModal;
